/* eslint-disable */
import { produce } from "immer";
import {
  YOUR_GOALS_FETCH_START,
  YOUR_GOALS_FETCH_SUCCESS,
  YOUR_GOALS_FETCH_FAILURE,
} from "../actions/types";

const yourGoals = (
  state = {
    fetching: false,
    data: {},
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case YOUR_GOALS_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case YOUR_GOALS_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case YOUR_GOALS_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default yourGoals;
